// Generated by OrchestKit Claude Plugin
// Created: 2026-09-10

import type { Barre } from '../../composants/ui/index.ts';

/** Jours de la semaine, tels qu'ils s'affichent sous les barres. */
const JOURS = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];

/**
 * Construit les sept barres à partir de la série renvoyée par l'API.
 *
 * Le serveur ne renvoie QUE les jours où il y a eu des ventes : un dimanche
 * de fermeture n'existe pas dans sa réponse. Afficher tel quel donnerait un
 * histogramme à quatre barres qu'on lirait comme quatre jours consécutifs —
 * et une semaine molle passerait pour une semaine pleine.
 *
 * On reconstruit donc les sept jours, en posant zéro sur les absents.
 */
export function construireBarres(
  /**
   * Types VOLONTAIREMENT larges, parce que c'est la réalité du réseau.
   *
   * Le pilote PostgreSQL rend les `BIGINT` en chaînes — un entier 64 bits ne
   * tient pas dans un `number` — et les `DATE` tantôt en chaîne, tantôt en
   * objet `Date`. Déclarer `{ jour: string; montant: number }` faisait passer
   * les conversions ci-dessous pour superflues : les retirer a suffi à faire
   * tomber tout le tableau de bord (`jour.slice` sur un `Date`).
   */
  serie: { jour: string | Date; montant: number | string }[],
  jusquAu: string,
): Barre[] {
  const parJour = new Map<string, number>();
  for (const point of serie) {
    parJour.set(normaliser(point.jour), Number(point.montant));
  }

  const fin = new Date(`${jusquAu}T12:00:00`);
  const barres: Barre[] = [];

  for (let recul = 6; recul >= 0; recul -= 1) {
    const jour = new Date(fin);
    jour.setDate(fin.getDate() - recul);

    const cle = jour.toISOString().slice(0, 10);
    barres.push({
      libelle: JOURS[jour.getDay()] ?? '—',
      valeur: parJour.get(cle) ?? 0,
      aujourdhui: recul === 0,
    });
  }

  return barres;
}

/**
 * Ramène une date à `AAAA-MM-JJ`.
 *
 * Une `DATE` peut revenir en `2026-09-11`, en `2026-09-11T00:00:00.000Z` ou
 * en objet `Date` selon le pilote et la configuration. Comparer sans
 * normaliser ferait échouer la correspondance en silence : toutes les barres
 * tomberaient à zéro, et l'écran afficherait une semaine sans ventes.
 *
 * Le `String()` n'est PAS superflu : sur un objet `Date`, `.slice` n'existe
 * pas et l'écran entier cesse de se rendre.
 */
function normaliser(jour: string | Date): string {
  return String(jour).slice(0, 10);
}
